export default __webpack_public_path__ + "media/images/managing_guests-e916cb2cb03ba20bfc981317f56be05d.svg";